import React from 'react';
import { Stack, Text } from '@fluentui/react';

const QuoteInfo: React.FC<{ type: string; content: any }> = ({ type, content }) => {
    if (type !== 'quote') return null;
    const { quote, author } = content || {};
    if (!quote) return null;

    return (
        <Stack styles={{ root: { width: '50%', backgroundColor: '#EAF1FB', padding: 40, borderRadius: 10 } }}>
            <Text variant="xLarge" style={{ fontWeight: 'bold', marginBottom: 10 }}>
                &ldquo;{quote}&rdquo;
            </Text>
            <Text variant="medium" style={{ fontStyle: 'italic', textAlign: 'right', marginTop: 10 }}>
                - {author}
            </Text>
        </Stack>
    );
};

export default QuoteInfo;
